import {
  ADD_RESET_PASSWORD_FIELD_ERROR,
  CHANGE_RESET_PASSWORD_FORM_FIELD,
  CLEAR_RESET_PASSWORD_FIELD_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST_FAILURE,
  RESET_PASSWORD_REQUEST_SUCCESS,
} from './actions'

export const initialState = () => {
  return {
    formData: {
      password: '',
    },
    resetEmailSuccessful: false,
    errors: {},
    loading: false,
  }
}

export default function reducer(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_RESET_PASSWORD_FORM_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        errors: {},
      }

    case RESET_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        resetEmailSuccessful: true,
        loading: false,
      }

    case RESET_PASSWORD_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }

    case ADD_RESET_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case CLEAR_RESET_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    default:
      return state
  }
}
